<template>
  <auth class="bg-white">
    <div id="login_main">
      <joat id="login_joat" vertical class="fc-main fs-biggest"></joat>
      <div id="login_body" class="bg-white br-big ">

        <custom-input icon="fa-user" placeholder="Username" v-model="form.username" @keypress.enter.native="login"></custom-input>
        <custom-input icon="fa-key" placeholder="Password" hidden v-model="form.password" @keypress.enter.native="login"></custom-input>

        <button @click="login" id="login_login" class="bt-normal bt bt-hover-light bg-main fc-white fs-small">
          <span v-if="!loading">LOGIN</span>
          <loader v-else></loader>
        </button>
        <a :href="registerRoute" target="_blank" id="login_signup" class="ff-inter fc-main tx-none fs-small">SIGNUP</a>
      </div>
      <div id="login_footer">

      </div>
    </div>
  </auth>
</template>

<script>
  import Auth from '../components/layouts/Auth'
  import Joat from '../components/miscellaneous/joat'
  import CustomInput from '../components/miscellaneous/customInput'
  import Loader from '../components/miscellaneous/loader'
  export default {
    name: 'Login',
    components: { Loader, CustomInput, Joat, Auth },
    data(){
      return{
        form: {
          username: '',
          password: ''
        },
        loading: false,
        registerRoute: `${process.env.VUE_APP_CUSAFE_URL}/register`
      }
    },
    computed:{
      formFilled(){
        if(this.form.username && this.form.password){
          return true;
        }else{
          return false;
        }
      }
    },
    methods: {
      login(){
        this.loading = true;
        this.$store.dispatch('User/login', this.form);
  }
    }
  }
</script>

<style scoped>
  #login_main{
    display: flex;
    height: 500px;
    width: 400px;
    flex-direction: column;
  }
  #login_header{
    display: flex;
    padding: 10px;
  }
  #login_body{
    display: flex;
    padding: 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  #login_login{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    margin-top: 20px;
  }
  #login_signup{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
  }
  #login_joat{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
</style>
